module.exports = __webpack_public_path__ + "img/logo_min.95335f0c.png";